export enum VendorType {
  GeneralAgency = 'GENERAL_AGENCY',
  LawFirm = 'LAW_FIRM',
  TranslationAgency = 'TRANSLATION_AGENCY',
  ClientVendor = 'CLIENT_VENDOR',
  Other = 'OTHER',
  Freelancer = 'FREELANCER',
}

// Only keeping this for legacy use since we can't convert every usage to the enum (it will break the system)
// This is what we should use when comparing types because they are defined as string from a long time ago.
export const VENDOR_TYPE_VALUE = {
  GeneralAgency: VendorType.GeneralAgency.toString(),
  LawFirm: VendorType.LawFirm.toString(),
  TranslationAgency: VendorType.TranslationAgency.toString(),
  Other: VendorType.Other.toString(),
  Freelancer: VendorType.Freelancer.toString(),
  ClientVendor: VendorType.ClientVendor.toString(),
};

export const VENDOR_TYPE_SELECT_ITEMS = [
  { label: 'General Agency', value: VENDOR_TYPE_VALUE.GeneralAgency },
  { label: 'Law Firm', value: VENDOR_TYPE_VALUE.LawFirm },
  { label: 'Translation Agency', value: VENDOR_TYPE_VALUE.TranslationAgency },
  { label: 'Freelancer', value: VENDOR_TYPE_VALUE.Freelancer },
  { label: 'Other', value: VENDOR_TYPE_VALUE.Other },
  { label: 'Client Vendor', value: VENDOR_TYPE_VALUE.ClientVendor },
];
